import React from "react";
import { Badge, Box, Button, Heading, HStack, Stack, Text } from "@chakra-ui/react";
import { fullName } from "../helpers";
import { Homeowner } from "../types";

type SelectedHomeownerSummaryProps = {
  homeowner: Homeowner | null;
  onChangeHomeowner?: () => void;
};

export const SelectedHomeownerSummary = ({
  homeowner,
  onChangeHomeowner,
}: SelectedHomeownerSummaryProps) => {
  if (!homeowner) {
    return null;
  }

  return (
    <Box bg="white" borderWidth="1px" borderColor="gray.200" rounded="md" p={4}>
      <HStack justify="space-between" align="start" mb={3}>
        <Box>
          <Heading size="sm">{fullName(homeowner)}</Heading>
          <Text color="gray.600" fontSize="sm">
            {homeowner.email || "No email"}
          </Text>
        </Box>
        <Stack align="flex-end" spacing={2}>
          <Badge colorScheme="green">Homeowner</Badge>
          {onChangeHomeowner && (
            <Button size="xs" variant="outline" onClick={onChangeHomeowner}>
              Change
            </Button>
          )}
        </Stack>
      </HStack>
      <Stack spacing={2} fontSize="sm" color="gray.700">
        <Text>{homeowner.phoneNumber || "No phone number"}</Text>
        <Text>Profile: {homeowner.clientProfile?.id || "N/A"}</Text>
        <Text>Saved addresses: {homeowner.addresses?.length || 0}</Text>
      </Stack>
    </Box>
  );
};
